import { render, staticRenderFns } from "./AddEditInsuranceModal.vue?vue&type=template&id=848dc1aa&"
import script from "./AddEditInsuranceModal.vue?vue&type=script&lang=js&"
export * from "./AddEditInsuranceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports